module.exports = __webpack_public_path__ + "static/img/img_guanyu_women_banner.93d77999.png";